//@ts-nocheck
import React, { forwardRef, useState } from 'react';
import { Input, Select } from 'antd';

import countriesList from 'utils/countries';

const { Option } = Select;

type CountryType = {
  code: string;
  dial_code: string;
  latitude?: number | string;
  longitude?: number | string;
  name: string;
};

type PhoneInputProps = {
  countries: Array<CountryType>;
  value?: { dial: string; number: string };
  onChange?: (e: object, value: { dial?: string; number?: string }) => void;
};

type SelectBeforeProps = {
  countries: Array<CountryType>;
  value: string;
  onChange: (value: string) => void;
};

const SelectBefore: React.FC<SelectBeforeProps> = ({ countries, ...props }) => (
  <Select
    showSearch
    popupMatchSelectWidth={false}
    style={{ width: '72px' }}
    css=".ant-select-selector { height: 30px !important; }"
    {...props}
  >
    {countries.map((country) => (
      <Option key={country.code} value={country.dial_code}>
        {country.dial_code}
      </Option>
    ))}
  </Select>
);

const PhoneInput: React.FC<PhoneInputProps> = (
  { countries, value = {}, onChange, ...props },
  ref
) => {
  const [number, setNumber] = useState(value?.number || '');
  const [dial, setDial] = useState(value?.dial || '');
  const triggerChange = (changedValue: { dial?: string; number?: string }) => {
    if (onChange) {
      onChange({ dial, number, ...changedValue }, changedValue);
    }
  };

  return (
    <span ref={ref}>
      <Input
        css={`
          .ant-input-group {
            margin-top: 1px;
          }
        `}
        value={number}
        addonBefore={
          <SelectBefore
            value={dial}
            onChange={(v: string) => {
              setDial(v);
              triggerChange({ dial: v });
            }}
            countries={countries}
          />
        }
        {...props}
        onChange={(e) => {
          const v = e.target.value.replace(/\D/, '');
          if (v !== number) {
            setNumber(v);
            triggerChange({ number: v });
          }
        }}
      />
    </span>
  );
};

const countries: Array<CountryType> = countriesList
  .sort(
    (a: CountryType, b: CountryType) =>
      parseInt(a.dial_code.replace(/\D/g, ''), 10) -
      parseInt(b.dial_code.replace(/\D/g, ''), 10)
  )
  .filter(
    (value, index, self) =>
      self.findIndex((x) => x.dial_code === value.dial_code) === index
  );

export default forwardRef((props, ref) =>
  PhoneInput({ ...props, countries }, ref)
);
